module.exports = __webpack_public_path__ + "img/sup_payment_method_banner.e9e01b5a.jpg";